module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    attrs: {
      "id": "conformbox"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper-main"
  }, [_c('div', {
    staticClass: "mz-header"
  }, [_c('span', [_vm._v("确认加入人才库")]), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-guanbi",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mz-content"
  }, [_c('div', {
    staticClass: "mz-cqr"
  }, [_vm._v("确认将 "), _c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v("加入企业人才库？")]), _vm._v(" "), _c('p', {
    staticClass: "mz-cxh"
  }, [_vm._v("需要消耗10平台币完成操作")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "mz-btn mz-btn-blue",
    class: {
      'my-btn-gray': _vm.myinfo.collNum * 1 == 0
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.myinfo.collNum ? '免费加入' : '暂无次数') + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mz-sycs",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', [_vm._v("剩余免费次数：" + _vm._s(_vm.myinfo.collNum) + "次")]), _vm._v(" "), (_vm.showpwd) ? _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "12px",
      "right": "4px",
      "color": "#ff4949",
      "font-size": "12px"
    }
  }, [_vm._v("请输入您的支付密码")]) : _vm._e()]), _vm._v(" "), (!_vm.showpwd) ? _c('div', {
    staticClass: "mz-btn mz-btn-orange",
    on: {
      "click": _vm.pingchange
    }
  }, [_vm._v("使用平台币下载")]) : _vm._e(), _vm._v(" "), (_vm.showpwd) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "46px"
    }
  }, [_c('ul', {
    staticClass: "mz-pwd"
  }, _vm._l((_vm.pwdlist), function(item) {
    return _c('li', [_vm._v(_vm._s(item))])
  })), _vm._v(" "), ((_vm.inputType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwdIinps),
      expression: "pwdIinps"
    }],
    staticClass: "mz-btn mz-btn-orange mz-inp-orange",
    attrs: {
      "maxlength": "6",
      "placeholder": "请输入密码",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwdIinps) ? _vm._i(_vm.pwdIinps, null) > -1 : (_vm.pwdIinps)
    },
    on: {
      "focus": _vm.focusInput,
      "change": function($event) {
        var $$a = _vm.pwdIinps,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwdIinps = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pwdIinps = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pwdIinps = $$c
        }
      }
    }
  }) : ((_vm.inputType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwdIinps),
      expression: "pwdIinps"
    }],
    staticClass: "mz-btn mz-btn-orange mz-inp-orange",
    attrs: {
      "maxlength": "6",
      "placeholder": "请输入密码",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwdIinps, null)
    },
    on: {
      "focus": _vm.focusInput,
      "change": function($event) {
        _vm.pwdIinps = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwdIinps),
      expression: "pwdIinps"
    }],
    staticClass: "mz-btn mz-btn-orange mz-inp-orange",
    attrs: {
      "maxlength": "6",
      "placeholder": "请输入密码",
      "type": _vm.inputType
    },
    domProps: {
      "value": (_vm.pwdIinps)
    },
    on: {
      "focus": _vm.focusInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwdIinps = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "mz-account"
  }, [_c('li', {
    staticClass: "mz-content-l"
  }, [_vm._v("当前账户余额："), _c('span', [_vm._v(_vm._s(_vm.myinfo.availableFunds) + "元")])]), _vm._v(" "), _c('li', {
    staticClass: "mz-content-r",
    on: {
      "click": _vm.gocharge
    }
  }, [_vm._v("我要充值>>")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', [_vm._v("您将会获得以下权限：")]), _vm._v(" "), _c('dd', [_vm._v("显示简历的联系方式")]), _vm._v(" "), _c('dd', [_vm._v("随时随地查看人才信息")]), _vm._v(" "), _c('dd', [_vm._v("简历将被永久加入人才库")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b36acb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resume/confirm.vue
// module id = 855
// module chunks = 1